import {type SWRConfiguration} from 'web-app/util/swr';

// Omitting 'fetcher' due to mismatch between 'SWRConfiguration' and what 'SWRConfig' expects
export const SWRConfigValue: Omit<SWRConfiguration, 'fetcher'> = {
    revalidateOnFocus: false,
};
